module.exports = __webpack_public_path__ + "img/154.aaa2a0d3.jpg";